"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.PScriptInfo = void 0;
var PMaybe_1 = require("../../../../lib/std/PMaybe/PMaybe.js");
var pstruct_1 = require("../../../../PTypes/PStruct/pstruct.js");
var types_1 = require("../../../../type_system/types.js");
var PCredential_1 = require("../../../V1/Address/PCredential.js");
var PCurrencySymbol_1 = require("../../../V1/Value/PCurrencySymbol.js");
var PProposalProcedure_1 = require("../../Governance/PProposalProcedure.js");
var PVoter_1 = require("../../Governance/PVoter.js");
var PTxOutRef_1 = require("../../Tx/PTxOutRef.js");
var PCertificate_1 = require("../PCertificate.js");
exports.PScriptInfo = (0, pstruct_1.pstruct)({
    Minting: { currencySym: PCurrencySymbol_1.PCurrencySymbol.type },
    Spending: {
        utxoRef: PTxOutRef_1.PTxOutRef.type,
        datum: (0, PMaybe_1.PMaybe)(types_1.data).type
    },
    Rewarding: { stakeCredential: PCredential_1.PCredential.type },
    Certifying: {
        index: types_1.int,
        cert: PCertificate_1.PCertificate.type
    },
    Voting: {
        voter: PVoter_1.PVoter.type
    },
    Proposing: {
        index: types_1.int,
        proposal: PProposalProcedure_1.PProposalProcedure.type
    }
});
